import { Injectable } from '@angular/core';
import { InputAccessoriesService } from 'src/app/services/input-accessories/input-accessories.service';
import { LoggerService } from 'src/app/services/logger/logger.service';

@Injectable({
	providedIn: 'root',
})
export class FnCtrlKeySwapFeature {
	constructor(
		private inputAccessoriesService: InputAccessoriesService,
		private logger: LoggerService
	) {}

	public async getCapabililty(): Promise<boolean> {
		try {
			const hasCapability = await this.inputAccessoriesService.GetFnCtrlSwapCapability();
			this.logger.info('FnCtrlKeySwapFeature capability: ', hasCapability);

			return hasCapability;
		} catch (error) {
			this.logger.error('FnCtrlKeySwapFeature error: ', error.message);

			return false;
		}
	}
}
